import { render, staticRenderFns } from "./dict-add-or-update.vue?vue&type=template&id=21195d23&"
import script from "./dict-add-or-update.vue?vue&type=script&lang=js&"
export * from "./dict-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports